import classNames from 'classnames';
import React from 'react';

import {PAGE_TYPE_FEATURED_TOPICS} from '@udemy/discovery-api';
import {useI18n} from '@udemy/i18n';

import {TopicListCollectionStore} from './components/featured-topic-list/topic-list-collection.mobx-store';
import {TopicListCollection} from './components/featured-topic-list/topic-list-collection.react-component';
import {FeaturedTopicsUnit} from './components/featured-topics-unit';
import styles from './featured-topics.module.less';

export function FeaturedTopics() {
    const {gettext} = useI18n();
    const pageType = PAGE_TYPE_FEATURED_TOPICS;
    const [topicListCollectionStore] = React.useState(() => new TopicListCollectionStore(gettext));

    return (
        <div className="ud-container ud-page-wrapper">
            <div className={styles['jumbotron-content-container']}>
                <h1 className="ud-heading-serif-xl">{gettext('Popular and trending topics')}</h1>
                <div>
                    {gettext('Learn something completely new or improve your existing skills')}
                </div>
            </div>

            <FeaturedTopicsUnit pageType={pageType} />

            <div
                className={classNames(
                    'ud-container',
                    styles['featured-topics-container-collection'],
                )}
            >
                <TopicListCollection store={topicListCollectionStore} />
            </div>
        </div>
    );
}
